import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "portfolio",
  class: "page"
}
const _hoisted_2 = { class: "page-content default" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Portfolio", -1)
const _hoisted_4 = { id: "featured" }
const _hoisted_5 = { id: "featured-projects" }
const _hoisted_6 = { id: "archive" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Archive", -1)
const _hoisted_8 = { id: "archive-projects" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeaturedProjectCard = _resolveComponent("FeaturedProjectCard")!
  const _component_ArchivedProjectCard = _resolveComponent("ArchivedProjectCard")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuredProjects, (project) => {
            return (_openBlock(), _createElementBlock("li", {
              key: project.title
            }, [
              _createVNode(_component_FeaturedProjectCard, { project: project }, null, 8, ["project"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archivedProjects, (project) => {
            return (_openBlock(), _createElementBlock("li", {
              key: project.title
            }, [
              _createVNode(_component_ArchivedProjectCard, { project: project }, null, 8, ["project"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}